import { Either } from '@sola/schema/dotcom/helpers.ts';
import { IconNames, IconNamesSafe } from '@sola/schema/lib/icons/icon-names.ts';

export type ArkIconProps = Omit<
  React.ComponentPropsWithoutRef<'svg'>,
  'children'
> & {
  /**
   * If icon needs accessibility, set aria-hidden to false
   * and include an accessible title or aria-labelledby.
   */
  alt?: string;
  size?: string;
} & Either<
    {
      iconName: IconNames;
    },
    {
      children: React.ReactElement;
    }
  >;

export const ArkIcon: React.FC<ArkIconProps> = ({
  iconName,
  alt,
  size,
  fill,
  children,
  ...props
}) => {
  return (
    <svg
      width={size || '1em'}
      height={size || '1em'}
      role="img"
      fill={fill || 'none'}
      aria-hidden={!alt || !!props['aria-labelledby'] || undefined}
      {...props}
    >
      {alt && <title>{alt}</title>}
      {children || (
        <use
          href={`/sprites/icons.svg#cicon-${IconNamesSafe.parse(iconName)}`}
        />
      )}
    </svg>
  );
};
